import { type FC } from "react"
import { ReactComponent as LogoutSvg } from "../../assets/svg/logout.svg"

const LogoutIcon: FC = () => <LogoutSvg/>

export default LogoutIcon
